var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"manager-reset-button",attrs:{"native-type":"button","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._v("重置")])
}
var staticRenderFns = []

export { render, staticRenderFns }